import { render, staticRenderFns } from "./ProblemPassageCurriculumUnit.vue?vue&type=template&id=773c78e5&scoped=true&lang=pug&"
import script from "./ProblemPassageCurriculumUnit.vue?vue&type=script&lang=ts&"
export * from "./ProblemPassageCurriculumUnit.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemPassageCurriculumUnit.vue?vue&type=style&index=0&id=773c78e5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c78e5",
  null
  
)

export default component.exports